import React, { useEffect, useState } from 'react';
import SingleFileUploadCreate from './UploadFile';
import UploadZIPCreate from './UploadZIP';
import { ListButton, Title, useResourceContext } from 'react-admin';

const SINGLE_UPLOAD = 'single';
const ZIP_UPLOAD = 'zip';

const UploadFileCreate = () => {
    const [activeRadio, setActiveRadio] = useState(SINGLE_UPLOAD);
    const resources = useResourceContext();

    return (
        <div>
            <Title title="Customer File Uploads" />
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>

                <div>
                    <h4 style={{ marginBottom: 5 }}>Select File Upload type</h4>

                    <label style={{ marginRight: 20 }}>
                        <input
                            type="radio"
                            name="uploadType"
                            value="single"
                            onChange={() => setActiveRadio(SINGLE_UPLOAD)}
                            checked={activeRadio === SINGLE_UPLOAD}
                        />
                        Upload Single File
                    </label>

                    <label>
                        <input
                            type="radio"
                            name="uploadType"
                            value="zip"
                            onChange={() => setActiveRadio(ZIP_UPLOAD)}
                            checked={activeRadio === ZIP_UPLOAD}
                        />
                        Upload ZIP File
                    </label>
                </div>
                <div className="notification-list-button"><ListButton basePath={resources} /></div>
            </div>


            {activeRadio === SINGLE_UPLOAD && (
                <SingleFileUploadCreate />
            )}

            {activeRadio === ZIP_UPLOAD && (
                <UploadZIPCreate />
            )}
        </div>
    )
};

export default UploadFileCreate;